/**
 * Redux reducer - this should be a pure function
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'SET_PAGE_TEMPLATE':
      return Object.assign({}, state, {
        pageTemplate: action.pageTemplate
      });
    default:
      return state;
  }
});